import { render, staticRenderFns } from "./projectDashboard.vue?vue&type=template&id=86c1c942&scoped=true&"
import script from "./projectDashboard.vue?vue&type=script&lang=js&"
export * from "./projectDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c1c942",
  null
  
)

export default component.exports